import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getStoreLocalData, getUserData } from "../../utils/localStorage";
import StoreMenu from "../StoreMenu";
import { getPriceCode } from "../../services/StorePriceCode/getPriceCode";
import ButtonLink from "../../ButtonLink";

const StorePriceCode = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [storeUserData, setStoreUserData] = useState([]);

  const [packageData, setPackageData] = useState([]);
  const [priceListData, setPriceListData] = useState([]);

  const { storeData } = getUserData();
  const [loading, setLoading] = useState(false);
  const enabledAddGarmentServicePrice = storeData.enabledAddGarmentServicePrice;

  const { storeLocalData } = getStoreLocalData();

  const storeId = storeData.id;
  const fetchPriceCode = () => {
    setLoading(true);
    getPriceCode(storeId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setPackageData(res.packages);
          setPriceListData(res.prices);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchPriceCode();
  }, []);

  const handleUpdatePrice = (item) => {
    navigate("/tariff-list-selection", {
      state: {
            priceListData: item,
          },
    })
  }

  const handleUpdatePackage = (item) => {
    navigate("/package-list-selection", {
      state: {
            packageListData: item,
          },
    })
  }

  const renderCardPriceListItem = () => {
    return priceListData?.map((item, index) => (
      <div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-lg  font-bold ">{item.priceCode}</p>
              </div>
               {enabledAddGarmentServicePrice && <div className="py-1 px-2 cursor-pointer" style={{
                      backgroundColor: "#1752AA",
                      borderRadius: 5,
                      marginRight: 20,
                    }} onClick={() => handleUpdatePrice(item)}>
                  <p className=" text-lg text-white font-bold ">Update Price List</p>
                </div>}
            </div>
          </div>
        </div>
        <div className="flex-1 ">
          <div className="m-4 shadow-4">
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Price Type :
                </p>
                <p className="text-lg font-medium capitalize">
                  {item.priceType}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Status :
                </p>
                {item.status === true ? (
                  <div className="flex ">
                    <p className="text-lg font-medium capitalize mr-2">
                      Active{" "}
                    </p>
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                ) : (
                  <div className="flex ">
                    <p className="text-lg font-medium capitalize mr-2">
                      DeActive{" "}
                    </p>
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderCardItem = () => {
    return packageData?.map((item, index) => (
      <div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-lg  font-bold ">{item.name}</p>
              </div>
              {enabledAddGarmentServicePrice && <div className="py-1 px-2 cursor-pointer" style={{
                      backgroundColor: "#1752AA",
                      borderRadius: 5,
                      marginRight: 20,
                    }} onClick={() => handleUpdatePackage(item)}>
                  <p className=" text-lg text-white font-bold ">Update Package List</p>
                </div>}
            </div>
          </div>
        </div>
        <div className="flex-1 ">
          <div className="m-4 shadow-4">
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Price Type :
                </p>
                <p className="text-lg font-medium capitalize">
                  {item.price.priceType}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Status :
                </p>
                {item.price.status === true ? (
                  <div className="flex ">
                    <p className="text-lg font-medium capitalize mr-2">
                      Active{" "}
                    </p>
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                ) : (
                  <div className="flex ">
                    <p className="text-lg font-medium capitalize mr-2">
                      DeActive{" "}
                    </p>
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                )}
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Amount :
                </p>
                <p className="text-lg font-medium capitalize">
                  {storeLocalData?.currencySymbol} {item.amount}
                </p>
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Service Unit :
                </p>
                <p className="text-lg font-medium capitalize">
                  {item.serviceUnit}
                </p>
              </div>

              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Quantity :
                </p>
                <p className="text-lg font-medium capitalize">
                  {item.quantity}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Description :
                </p>
                <p className="text-lg font-medium capitalize">
                  {item.description ? item.description : "N/A"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };
  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Store Price Code
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="flex justify-content-center m-3">
        <p className="text-2xl font-bold capitalize">Price List</p>
      </div>
      <div>{renderCardPriceListItem()}</div>
      <div className="flex justify-content-center m-3">
        <p className="text-2xl font-bold capitalize">Package List</p>
      </div>
      <div>{renderCardItem()}</div>
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default StorePriceCode;
